import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, createSlots as _createSlots } from "vue"

const _hoisted_1 = {
  class: "flex w-full justify-between items-center px-2 pb-5",
  style: {"border-bottom":"1px solid #CFD8DC"}
}
const _hoisted_2 = { class: "font-semibold text-xl text-black" }
const _hoisted_3 = { class: "excel-price-active px-3 " }
const _hoisted_4 = { class: " grid grid-rows-1 grid-flow-col gap-4 " }
const _hoisted_5 = { class: "flex flex-col" }
const _hoisted_6 = { class: "p-input-icon-left mb-2" }
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_8 = {
  class: "flex flex-col overflow-y-auto",
  style: {"height":"60vh"}
}
const _hoisted_9 = { class: " flex-shrink-0" }
const _hoisted_10 = { class: " mx-4" }
const _hoisted_11 = { class: "flex flex-col " }
const _hoisted_12 = { class: "font-bold text-xl" }
const _hoisted_13 = { class: "font-semibold mb-0 mt-0 color-blue-grey text-sm" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "my-no-more" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Pilih Tujuan")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Kembali")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_RadioButton = _resolveComponent("RadioButton")
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")
  const _component_VueEternalLoading = _resolveComponent("VueEternalLoading")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.isShowDialog,
    "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => (_ctx.isShowDialog = $event)),
    modal: true,
    dismissableMask: true,
    onHide: _cache[8] || (_cache[8] = ($event: any) => (_ctx.hideDialog())),
    breakpoints: { '960px': '75vw', '640px': '90vw' },
    style: { width: '50vw' }
  }, _createSlots({
    header: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("h6", _hoisted_2, _toDisplayString(_ctx.title), 1),
        _createVNode("i", {
          class: "pi pi-times text-black cursor-pointer",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hideDialog()))
        })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_InputText, {
                type: "text",
                modelValue: _ctx.searchValue,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchValue = $event)),
                placeholder: "Search",
                class: "min-w-full",
                autofocus: ""
              }, null, 8, ["modelValue"])
            ]),
            _createVNode("div", _hoisted_8, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listAgent, (item, index) => {
                return (_openBlock(), _createBlock("div", {
                  key: item.Id
                }, [
                  _createVNode("div", {
                    class: "flex items-center p-2 border-b-2 ",
                    index: index,
                    style: _ctx.setStyleSheet(item),
                    onClick: ($event: any) => (_ctx.selectAct(item))
                  }, [
                    _createVNode("div", _hoisted_9, [
                      _createVNode(_component_RadioButton, {
                        id: "data-{{item.Id}}",
                        name: "city",
                        modelValue: _ctx.selectedData,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedData = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _createVNode("div", _hoisted_10, [
                      _createVNode("div", _hoisted_11, [
                        _createVNode("div", _hoisted_12, _toDisplayString(item.Nama), 1),
                        _createVNode("div", _hoisted_13, _toDisplayString(item.Kota.Nama), 1)
                      ])
                    ])
                  ], 12, ["index", "onClick"])
                ]))
              }), 128)),
              _createVNode(_component_VueEternalLoading, {
                load: _ctx.loadData,
                "is-initial": _ctx.isInitial,
                "onUpdate:is-initial": _cache[4] || (_cache[4] = ($event: any) => (_ctx.isInitial = $event)),
                class: "flex justify-center"
              }, {
                loading: _withCtx(() => [
                  _createVNode(_component_ProgressSpinner, {
                    class: "h-8",
                    strokeWidth: "5"
                  })
                ]),
                "no-more": _withCtx(() => [
                  _hoisted_14
                ]),
                _: 1
              }, 8, ["load", "is-initial"])
            ])
          ])
        ])
      ])
    ]),
    _: 2
  }, [
    false
      ? {
          name: "footer",
          fn: _withCtx(() => [
            _createVNode(_component_Button, {
              class: "btn-primary text-black mr-3 ",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sendSelectedData()))
            }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1
            }),
            _createVNode(_component_Button, {
              class: "btn-secondary text-black ",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.hideDialog()))
            }, {
              default: _withCtx(() => [
                _hoisted_16
              ]),
              _: 1
            })
          ])
        }
      : undefined
  ]), 1032, ["visible"]))
}